<script>
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import {cloneDeep} from 'lodash';
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: 'ServiceFeeTemplate',
    components: {
        MaskedInput,
        RawData
    },
    props: {
        template: {
            type: [Object, null],
            default: () => {}
        },
        useMeterReading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        feeToSave(){
            let data = this.template.deliveryUnitServiceFees;
            return data.filter(x => x.id == 0);
        },
        selectAll: {
            get(){
                return this.template.deliveryUnitServiceFees.filter(x => x.selected).length == this.template.deliveryUnitServiceFees.length;
            },
            set(newValue){
                this.template.deliveryUnitServiceFees.map(item => item.selected = newValue);
            }
        },
        selectedFee(){
            return this.template.deliveryUnitServiceFees.filter(x => x.selected);
        }
    },
    data(){
        return {
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: true,
            }),
            multipleSelection: false,
        }
    },
    methods: {
        addFees(){
            this.$emit('addFees')
        },
        removeFee(index, data){
            if(data.id != 0){
                return data.editMode = false;
            }
            this.template.deliveryUnitServiceFees.splice(index, 1);
        },
        saveFees(){
            let dat = cloneDeep(this.feeToSave);
            dat.map(item => {
                item.amount = item.amount ? this.getExactAmt(item.amount) : 0;
                item.percentage = item.percentage ? this.getExactAmt(item.percentage) : 0;
            })
            this.$store
                .dispatch("duservicefeetemplate/addMultipleFee", {
                    deliveryUnitServiceFeeTemplateId: this.template.id,
                    data: dat
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.template.deliveryUnitServiceFees.map(item => {
                        let fin = res.data.find(x => x.feeId == item.feeId);
                        if(fin) item.id = fin.id;
                        item.amount = this.getExactAmt(item.amount);
                    })
                    this.showToast('Successfully saved!', 'success')
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot delete template.", "error");
                });
        },
        saveFee(data){
            let dat = cloneDeep(data);
            dat.amount = data.amount ? this.getExactAmt(data.amount) : 0;
            dat.percentage = data.percentage ? this.getExactAmt(data.percentage) : 0;
            this.$store
                .dispatch("duservicefeetemplate/updateFee", dat)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    data.editMode = false;
                    data.amount =  dat.amount.toString();
                    this.showToast('Successfully saved!', 'success')
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot save template.", "error");
                });
        },
        toggleSelection(type, data){
            this.multipleSelection = type;
            if(type && data.id == 0) return;
            if(type){
                data.selected = true;
            }
        },
        selectFee(data){
            if(data.id == 0) return;
            data.selected = !data.selected;
        },
        removeFees(){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    let ids = [];
                    let data = this.template.deliveryUnitServiceFees.filter(x => x.selected);
                    data.map(item => {
                        ids.push({id: item.id});
                    })
                    this.$store
                        .dispatch("duservicefeetemplate/removeFee", ids)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            data.map(item => {
                                let ind = this.template.deliveryUnitServiceFees.findIndex(x => x.id == item.id);
                                this.template.deliveryUnitServiceFees.splice(ind, 1)
                            })
                            this.multipleSelection = false;
                            this.showToast('Successfully removed!', 'success')
                        })
                        .catch((error) => {
                            console.log(error)
                            this.showToast("Something went wrong! Cannot remove fees.", "error");
                        });
                }
            })
        },
        getTotal(){
            let sum = 0;
            this.template.deliveryUnitServiceFees.map(item => {
                sum += parseFloat(this.getExactAmt(item.amount))
            })
            return sum;
        }
    }

}
</script>
<template>
  <table class="table table-bordered">
    <thead>
        <tr>
            <th :colspan="multipleSelection ? 4: 3" class="p-2">
                <h4 class="mb-0 text-info">Fee Templates</h4>
                <button v-if="multipleSelection" type="button" class="btn btn-sm btn-warning ms-1" @click="toggleSelection(false)"><i class="bx bx-x"></i> Cancel Selection</button>
                <button v-if="multipleSelection && selectedFee.length" type="button" class="btn btn-sm btn-danger ms-1" @click="removeFees"><i class="bx bx-trash"></i> Remove Selected</button>
            </th>
            <th style="width:150px;"  class="p-2">
                <button type="button" class="btn btn-info btn-sm btn-block" @click="addFees" v-if="!feeToSave.length"><i class="bx bx-plus"></i> Add Fees</button>
                <button type="button" class="btn btn-success btn-sm btn-block" @click="saveFees" v-else><i class="bx bx-save"></i> Save All</button>
            </th>
        </tr>
        <tr>
            <th style="width:50px" v-if="multipleSelection" class="v-align-middle text-center">
                <a href="javascript:void(0);" :class="{'text-green': selectAll, 'text-secondary': !selectAll}" @click="selectAll = !selectAll">
                    <i class="bx font-size-22 font-weight-bold" :class="{'bx-check': selectAll, 'bx-x': !selectAll}"></i>
                </a>
            </th>
            <th>Name and Accounts</th>
            <th style="width:200px;">Default Amount</th>
            <th style="width:80px;" class="text-center">%</th>
            <th style="width:150px;" class="text-center">Action</th>
        </tr>
    </thead>
    <tbody>
        <tr v-if="!template.deliveryUnitServiceFees.length">
            <td colspan="100%" class="text-center">No data found.</td>
        </tr>
        <tr v-for="(x, xInd) in template.deliveryUnitServiceFees" :key="xInd">
            <td v-if="multipleSelection" @click="selectFee(x)" class="v-align-middle text-center py-1">
                <i class="bx font-size-22" :class="{'bx-check text-green font-weight-bold': x.selected, 'bx-x text-secondary font-weight-bold': !x.selected}"></i>
            </td>
            <td @dblclick="toggleSelection(true, x)" class="py-1 position-relative">
                <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                <div class="d-flex gap-1">
                    <a href="javascript:void(0)" class="mb-0 hover-underline d-block text-dark font-size-14 me-5" @click="selectFee(x)">{{x.feeName}}</a>
                    <div v-if="$store.state.decrypt.isAdmin() && useMeterReading" class="d-flex">
                        ( <div
                            class="
                                form-check
                                form-checkbox-outline
                                form-check-success
                                mb-0
                            "
                        >
                            <input
                                type="checkbox"
                                :id="`isExcess-${x.id}`"
                                checked="checked"
                                class="form-check-input"
                                v-model="x.isExcess"
                                :disabled="x.id != 0 && !x.editMode"
                            /><label
                                :for="`isExcess-${x.id}`"
                                class="form-check-label"
                            >
                                Excess
                            </label>
                        </div>
                        <div
                            class="
                                form-check
                                form-checkbox-outline
                                form-check-success
                                mb-0
                                ms-1
                            "
                        >
                            <input
                                type="checkbox"
                                :id="`isMin-${x.id}`"
                                checked="checked"
                                class="form-check-input"
                                v-model="x.isMin"
                                :disabled="x.id != 0 && !x.editMode"
                            /><label
                                :for="`isMin-${x.id}`"
                                class="form-check-label"
                            >
                                Minimum
                            </label>
                        </div> )
                    </div>
                </div>
                <small>{{x.account}}</small>
            </td>
            <td class="v-align-middle py-1 text-right" >
                <template v-if="x.id == 0 || x.editMode">
                    <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="x.amount"
                        placeholder="Enter Default Amount..."
                        class="form-control text-right w-100"
                        :mask="currencyMask"
                    ></masked-input>
                </template>
                <template v-else>
                    {{formatCurrency(x.amount)}}
                </template>
            </td>
            <td class="v-align-middle py-1 text-center" >
                <template v-if="x.id == 0 || x.editMode">
                    <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="x.percentage"
                        placeholder="Enter Default Amount..."
                        class="form-control text-right w-100"
                        :mask="currencyMask"
                    ></masked-input>
                </template>
                <template v-else>
                    {{x.percentage && x.percentage > 0 ? x.percentage + '%' : '-' }}
                </template>
            </td>
            <td class="v-align-middle text-center py-1">
                <template v-if="x.id == 0 || x.editMode">
                    <div class="d-flex justify-content-center gap-1">
                        <a href="javascript:void(0);" class="font-size-15 d-flex align-items-center gap-1 text-success" @click="saveFee(x)" v-if="x.id != 0">
                            <i class="bx bx-save"></i> <span class="hover-underline">Save</span>
                        </a>
                        <a href="javascript:void(0);" class="font-size-15 d-flex align-items-center gap-1 text-danger" @click="removeFee(xInd, x)">
                            <i class="bx bx-x"></i> <span class="hover-underline">Cancel</span>
                        </a>
                    </div>
                </template>
                <template v-else>
                    <div class="d-flex gap-2 justify-content-center">
                        <a href="javascript:void(0);" class="font-size-15 d-flex align-items-center gap-1" @click="x.editMode = !x.editMode">
                            <i class="bx bx-edit"></i> <span class="hover-underline">Edit</span>
                        </a>
                        <!-- <a href="javascript:void(0);" class="font-size-15 d-flex align-items-center gap-1 text-danger"><i class="bx bx-trash"></i> <span class="hover-underline">Delete</span></a> -->
                    </div>
                </template>
            </td>
        </tr>
        <tr>
            <td class="text-right py-2 bg-primary bg-soft font-weight-bold text-white" :colspan="multipleSelection ? 2: 1">Total: </td>
            <td class="py-2 bg-primary bg-soft font-weight-bold text-white text-right">{{formatCurrency(getTotal())}}</td>
            <td class="bg-primary bg-soft"></td>
            <td class="bg-primary bg-soft"></td>
        </tr>
    </tbody>
  </table>
</template>